import {
  LINES,
  STATIONS,
  TRAIN_POSITION_TABS,
  TRAIN_KINDS,
  TOKYU_SECTIONS,
  TOKYU_DESTINATION_CODES,
  NEARBY_STATIONS,
} from '../constants'

const merge = require('deepmerge')
const fs = require('fs')

class MasterData {
  static isOnMainLine = stationId => !!MasterData.lineStationById(stationId, 1)
  static isOnIzuminoLine = stationId => !!MasterData.lineStationById(stationId, 2)
  static isOnShinyokohamaLine = stationId => !!MasterData.lineStationById(stationId, 3)
  static lineIdByLineName = lineName => {
    switch(lineName) {
      case 'main': return 1
      case 'izumino': return 2
      case 'for_tokyu': return 3
      case 'for_jre': return 4
      default: return null
    }
  }
  
  // 列車種別に関するデータを取得
  static trainKindById = trainKindId => TRAIN_KINDS.find(kind => kind.id === trainKindId)

  // JRの列車種別コードより列車種別に関するデータを取得
  static trainKindByJrTrainType = jrTrainType => TRAIN_KINDS.find(tk => tk.jr_train_type && tk.jr_train_type === jrTrainType)

  // 東急の列車種別コードより列車種別に関するデータを取得
  static trainKindByTokyuTrainKindId = tokyuTrainKindId => TRAIN_KINDS.find(tk => tk.tokyu_train_kind_id && tk.tokyu_train_kind_id === tokyuTrainKindId)

  // 東急の駅間ID(section_id)IDより下り方向の次駅tokyuKYIDを取得
  static nextTokyuKYIDBySectionId = function(sectionId){
    const section = TOKYU_SECTIONS.find(section => section.section_id === sectionId)
    if (section) {
      return section.tokyuKYId
    }
  }

  static isEdgeStation = function(stationId){
    return stationId && this.station(stationId).egdeStation
  }

  static isOnJrStation = function(stationId) {
    return stationId && this.station(stationId) && this.station(stationId).jrStation
  }

  static isOnJrStationBeyondShinjuku(station_id) {
    // 池袋〜川越
    return (43 <= station_id && station_id <= 48)
  }

  // 東横線直通方面（新綱島〜日吉〜渋谷〜副都心線・東武線）新横浜駅を除く
  static isOnToyokoToward = function(stationId) {
    return stationId && this.station(stationId) && [301, 311, 312, 313, 314].some(i => this.station(stationId).line_ids.includes(i)) && stationId !== 29
  }

  // 目黒線直通方面（新綱島〜日吉〜目黒〜南北線・三田線）新横浜駅を除く
  static isOnMeguroToward = function(stationId) {
    return stationId && this.station(stationId) && [301, 321, 322, 323, 324].some(i => this.station(stationId).line_ids.includes(i)) && stationId !== 29
  }

  static isOnTokyuLine = function(stationId) {
    return stationId && this.station(stationId) && [301, 311, 321].some(i => this.station(stationId).line_ids.includes(i))
  }

  // 菊名・横浜・みなとみらい・元町中華街
  static isOnToyokoLineMotomachiToward = function(stationId) {
    return [30093, 30098, 30100, 30103].includes(stationId)
  }

  static isSectionOnJrLine(station_id, next_station_id, direction) { // 指定された駅間がJR線の管轄かどうか
    return (
      (station_id && this.isOnJrStation(station_id)) ||
      (next_station_id && this.isOnJrStation(next_station_id)) ||
      (station_id === 28 && direction === 'up') ||
      (next_station_id === 28 && direction === 'down')
    )
  }

  static isSectionBetweenHazawaToKosugi(next_station_id, direction) { // 羽沢→武蔵小杉間に在線かどうか
    return next_station_id === 11464 && direction === 'up'
  }

  static isSectionBetweenKosugiToHazawa(next_station_id, direction) { // 武蔵小杉→羽沢間に在線かどうか
    return next_station_id === 28 && direction === 'down'
  }

  static trainKindClassById = trainKindId => TRAIN_KINDS.find(kind => kind.id === trainKindId).icon_class

  static lines() {
    const apiLines = JSON.parse(fs.readFileSync('src/data/lines.json', 'utf8'))

    return LINES.map(line => {
      var apiLineHash = apiLines.find(apiLine => apiLine.id === line.id)
      if (apiLineHash) {
        const {stations: _, ...apiLineHashWithoutStations} = apiLineHash
        return merge(apiLineHashWithoutStations, line)
      } else {
        return line
      }
    })
  }

  static line = function(lineId) {
    return this.lines().find(line => line.id === lineId)
  }

  static stations = function() {
    const apiStations = JSON.parse(fs.readFileSync('src/data/stations.json', 'utf8'))

    return STATIONS.map(station => {
      const apiStationHash = apiStations.find(apiStation => apiStation.id === station.id)
      if (apiStationHash) {
        return merge(apiStationHash, station)
      } else {
        return station
      }
    })
  }

  static station = function(stationId) {
    return this.stations().find(station => station.id === stationId)
  }

  static lineStationById = function(stationId, lineId) {
    const tab = TRAIN_POSITION_TABS.find(tab => tab.lineId === lineId)
    const tabStation = tab.stations.flat().find(station => station.id === stationId)

    const station = this.station(stationId)

    if(station && tabStation) {
      return merge(station, tabStation)
    } else {
      return null
    }
  }

  static tabLineById = function(lineId) {
    const tab = TRAIN_POSITION_TABS.find(tab => tab.lineId === lineId)
    return tab
  }

  static trainPositionTab = function(lineId){
    return TRAIN_POSITION_TABS.find(tab => tab.lineId === lineId)
  }
  
  // 上り方向に1駅先の駅を返す（下り列車の駅間で使用）
  // いずみ野線の南万騎が原駅では、二俣川駅を返す
  // 田園調布では、trainLineIdに基づき自由が丘または奥沢を
  // 渋谷〜自由が丘、目黒〜奥沢では同じ路線の上り方向に1駅先の駅を
  // それ以外の路線が1本しかいない部分は上り方向の1駅前を返す
  static upNextStationId = function(lineId, stationId, trainLineId){
    // 特殊ケース1: いずみ野線の南万騎が原駅の上りは二俣川駅
    if (lineId === 2 && stationId === 21) {
      return 10
    }
    
    // 特殊ケース2: 田園調布駅（東横線と目黒線で分岐）
    if (stationId === 67) {
      return trainLineId === 26001 ? 68 : 118  // 東横線なら自由が丘(68)、目黒線なら奥沢(118)
    }
    
    const tab = TRAIN_POSITION_TABS.find(tab => tab.lineId === lineId)
    if (!tab) {
      console.error(`upNextStationId: lineId ${lineId} not found in TRAIN_POSITION_TABS`)
      return null
    }
    
    const stations = tab.stations
    
    // 通常ケース: 並行路線または単一路線の駅を探索
    let columnIndex = -1
    const stationRowIndex = stations.findIndex(stationRow => {
      if (Array.isArray(stationRow)) {
        // 並行路線（東横線渋谷〜自由が丘、目黒線目黒〜奥沢）
        if (stationRow[0].id === stationId) {
          columnIndex = 0
          return true
        } else if (stationRow[1].id === stationId) {
          columnIndex = 1
          return true
        }
        return false
      } else {
        // 単一路線
        return stationRow.id === stationId
      }
    })
    
    if (stationRowIndex >= 1) {
      if (columnIndex >= 0) {
        return stations[stationRowIndex - 1][columnIndex].id
      } else {
        return stations[stationRowIndex - 1].id
      }
    }
  }

  // 下り方向に1駅先の駅を返す（上り列車の駅間で使用）
  // 自由が丘または奥沢の場合は路線にかかわらず田園調布を返す
  static downNextStationId = function(lineId, stationId){
    const tab = TRAIN_POSITION_TABS.find(tab => tab.lineId === lineId)
    if (!tab) {
      console.error(`downNextStationId: lineId ${lineId} not found in TRAIN_POSITION_TABS`)
      return null
    }
    
    const stations = tab.stations
    var columnIndex = -1
    const stationRowIndex = stations.findIndex(stationRow => {
      if (stationId === 68 || stationId === 118) { // 自由が丘または奥沢ならば田園調布駅
        return stationRow[0].id === 68 // 自由が丘または奥沢の要素Index
      } else if (Array.isArray(stationRow)) {
        if (stationRow[0].id === stationId){ // 東横線渋谷〜都立大学
          columnIndex = 0
          return true
        } else if (stationRow[1].id === stationId){ // 目黒線目黒〜大岡山
          columnIndex = 1
          return true
        } else {
          return false
        }
      } else {
        return stationRow.id === stationId
      }
    })
    if (stations.length > stationRowIndex) {
      if (columnIndex >= 0){
        return stations[stationRowIndex + 1][columnIndex].id
      } else {
        return stations[stationRowIndex + 1].id
      }
    }
  }

  static allStationsOnTabId = function(lineId){
    return this.trainPositionTab(lineId).stations.map(station => {
      if (Array.isArray(station)){
        return station.map(stationElem => {
          return {...this.station(stationElem.id), ...stationElem}
        })
      } else {
        return {...this.station(station.id), ...station}
      }
    })
  }

  static allStationsOnNearStation = function(stationId){
    const nearbyStations = NEARBY_STATIONS[stationId]
    if (!nearbyStations) {
      return []
    }
    return nearbyStations.map(station => {
      if (Array.isArray(station)){
        return station.map(stationElem => {
          if (stationElem === null) {
            return null
          }
          return {...this.station(stationElem.id), ...stationElem}
        })
      } else {
        return {...this.station(station.id), ...station}
      }
    })
  }

  static stationByTokyuDestinationCode = function(destinationStationCode){
    return TOKYU_DESTINATION_CODES.find(station => station.code === destinationStationCode)
  }
}
export default MasterData
